import ParameterErrors from '../errors/ParameterErrors';
import Model from './Model';
const { throwNotProvided } = ParameterErrors;
export default class Models {
    constructor(props) {
        const { map, mapGroupCodeToModels} = props;
        if (!map) throwNotProvided("map");
        if (!mapGroupCodeToModels) throwNotProvided("mapGroupCodeToModels");
        this._map = map;
		this._mapGroupCodeToModels = mapGroupCodeToModels;
		this.getModelByCode= this.getModelByCode.bind(this);
		this.getModelsByGroupCode= this.getModelsByGroupCode.bind(this);
    }
    getModelByCode(code) {
		if(!this._map.has(code))return null;
        return this._map.get(code);
    }
	getModelsByGroupCode(groupCode){
		return this._mapGroupCodeToModels.get(groupCode);
	}
    static fromJSON(objArray) {
        const modelsMap = new Map();
		const mapGroupCodeToModels = new Map();
        for (var i = 0; i < objArray.length; i++) {
			const model = Model.fromObj(objArray[i]);
            modelsMap.set(model.code, model);
			if(!mapGroupCodeToModels.has(model.groupCode)){
				mapGroupCodeToModels.set(model.groupCode, [model]);
			}
			else
				mapGroupCodeToModels.get(model.groupCode).push(model);
        }
        return new Models({ map: modelsMap , mapGroupCodeToModels:mapGroupCodeToModels});
    }
}
